import styled from 'styled-components';

export const StyledInput = styled.input`
  border-radius: 4px;
  padding: 0 8px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey2} !important;
  font-size: 13px;
  width: 53px;
`;
